<nz-form-item>
  <nz-form-label [nzSpan]="6" [nzRequired]="true">{{ '组织代码' | translate }}</nz-form-label>
  <nz-form-control [nzSpan]="16" [nzExtra]="'组织代码须以小写字母开头，可包含小写字母、数字、中划线' | translate">
    <input nz-input [value]="code()" (input)="onCodeInput($event)" type="text" />
  </nz-form-control>
</nz-form-item>
<nz-form-item>
  <nz-form-label [nzSpan]="6" [nzRequired]="true">{{ '组织名称' | translate }}</nz-form-label>
  <nz-form-control [nzSpan]="16">
    <input nz-input [value]="name()" (input)="onNameInput($event)" type="text" />
  </nz-form-control>
</nz-form-item>
